import Marquee from "react-fast-marquee";
import { IMAGES } from "@/lib/content";

const PHOTOS = [
  { src: IMAGES.babyUnderwater, label: "Underwater confidence" },
  { src: IMAGES.millyProfile, label: "On our way to you" },
  { src: IMAGES.backFloat, label: "Comfort in the water" },
  { src: IMAGES.millyHeadshot, label: "Meet Milly" },
  { src: IMAGES.mauiEdge, label: "Lessons that come to you" },
];

export const PhotoMarquee = () => (
  <section className="py-6 overflow-hidden" style={{ backgroundColor: "var(--navy)" }} data-testid="photo-marquee">
    <Marquee speed={40} gradient={false} pauseOnHover autoFill>
      {PHOTOS.map((p, i) => (
        <div key={i} className="relative mx-3 my-4 w-[280px] md:w-[340px] h-[240px] md:h-[300px] rounded-2xl overflow-hidden group">
          <img src={p.src} alt={p.label} className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-110" />
          <div className="absolute inset-0 flex items-end p-4" style={{ background: "linear-gradient(180deg, transparent 55%, rgba(11,27,61,0.8))" }}>
            <span className="font-display text-lg" style={{ color: "var(--cream)" }}>{p.label}</span>
          </div>
        </div>
      ))}
    </Marquee>
  </section>
);
